import { render, staticRenderFns } from "./AppDownloadPage.vue?vue&type=template&id=b42f9c8c&scoped=true&"
import script from "./AppDownloadPage.vue?vue&type=script&lang=js&"
export * from "./AppDownloadPage.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadPage.vue?vue&type=style&index=0&id=b42f9c8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42f9c8c",
  null
  
)

export default component.exports